import { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { Button, CaretToggle } from '@snapi/luxury';
import { BabyCard } from '../baby-card';
import { FirstBabyCard } from '../first-baby-card';
import { Baby } from '@snapi/types';

export interface BabySelectorProps {
  selected: Baby;
  editable: boolean;
  babies: Baby[];
  onChange(value: Baby): void;
  onEdit(): void;
}

export function BabySelector({
  selected,
  editable,
  babies,
  onChange,
  onEdit,
}: BabySelectorProps) {
  const babiesNames = babies.map((item) => {
    return item.name.substring(0, 1).toLocaleUpperCase();
  });

  return (
    <div className="flex flex-col flex-1">
      <Listbox value={selected} onChange={onChange}>
        {({ open }) => (
          <div className="relative">
            <Listbox.Button className="relative rounded-[10px] w-full bg-white text-left outline-none">
              <span className="flex">
                <FirstBabyCard
                  baby={selected}
                  onEdit={open || !editable ? undefined : onEdit}
                  babiesNames={babiesNames}
                  open={open}
                />
                <span className="self-center w-4 mr-5">
                  <CaretToggle open={open} />
                </span>
              </span>
            </Listbox.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-500"
              enterFrom="opacity-0 scale-50"
              enterTo="opacity-100 scale-100"
              leave="transition ease-in duration-500"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-0"
            >
              <Listbox.Options className="absolute -mt-2 pt-2 w-full overflow-auto bg-white rounded-b-[10px] divide-y divide-gray-soft z-[10]">
                <span />
                {babies
                  .filter(({ id }) => selected.id !== id)
                  .map((baby, i) => (
                    <Listbox.Option
                      key={baby.id}
                      className={({ active }) =>
                        clsx(
                          'cursor-pointer select-none items-center hover:bg-green-light',
                          active && 'bg-green-light'
                        )
                      }
                      value={baby}
                    >
                      <BabyCard baby={baby} />
                    </Listbox.Option>
                  ))}
              </Listbox.Options>
            </Transition>
          </div>
        )}
      </Listbox>
    </div>
  );
}
